document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    menu.hidden = expanded;
  }

  const quantityButton = event.target.closest('[data-quantity]');
  if (quantityButton) {
    const input = quantityButton.parentElement.querySelector('input');
    const change = quantityButton.dataset.quantity === 'plus' ? 1 : -1;
    input.value = Math.max(1, Number(input.value || 1) + change);
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const price = form.parentElement.querySelector('[data-product-price]');
  const button = form.querySelector('[type="submit"]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  button.disabled = option.dataset.available !== 'true';
  button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
});
